// extracted by mini-css-extract-plugin
module.exports = {"ddl-btn":"FormDdl-module__ddl-btn__kcPP5","form-container":"FormDdl-module__form-container__cxQRJ"};